import { Reveal, Overline } from "./Reveal";
import { MapPin } from "lucide-react";

export const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
        <Reveal className="relative">
          <div className="relative">
            <img
              src="https://customer-assets.emergentagent.com/job_howell-strength/artifacts/php6i6h7_IMG_7917.webp"
              alt="Ryan Howell, Transformation Coach"
              className="w-full aspect-[4/5] object-cover"
              data-testid="about-portrait"
            />
            <div className="absolute -bottom-6 -right-6 hidden sm:block bg-[#0055FF] px-8 py-6">
              <div className="font-display font-bold text-3xl text-white">250 → 150</div>
              <div className="text-xs uppercase tracking-widest text-white/80 mt-1">Pounds Lost</div>
            </div>
            <div className="absolute inset-0 border border-[#262626] pointer-events-none" />
          </div>
        </Reveal>

        <div>
          <Reveal>
            <Overline>About Ryan Howell</Overline>
            <h2 className="font-display font-semibold uppercase tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
              I Changed My Body.<br />It Changed My Life.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-[#A3A3A3] leading-relaxed">
              <p>
                Around five years ago I weighed approximately{" "}
                <span className="text-white font-semibold">250 pounds</span>. Through
                fitness, proper nutrition, discipline, and consistency, I completely
                transformed my life and eventually reached around{" "}
                <span className="text-white font-semibold">150 pounds</span>.
              </p>
              <p>
                That transformation changed much more than my body. It changed my
                confidence, mindset, discipline, work ethic, and the way I live every
                single day.
              </p>
              <p>
                Now my mission is helping other people experience that same
                transformation. I genuinely care about every client — this isn’t just
                another business to me. Helping people become healthier, stronger, and
                more confident is something I truly enjoy.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex items-start gap-3 border-l-2 border-[#0055FF] pl-4">
              <MapPin size={18} className="text-[#0055FF] mt-1 shrink-0" />
              <p className="text-sm text-white">
                Online coaching worldwide, virtual Zoom coaching, and in-home personal
                training throughout the{" "}
                <span className="font-semibold">Savannah, Georgia</span> area.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
